import axios from 'axios'
import {Notification} from 'element-ui'
import store from '@/store'


const http = axios.create({
  baseURL: 'https://www.hylkx.com/',
  timeout: 6000,
  headers: {
    //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

http.interceptors.request.use(config => {
    if (config.requireToken && store.getters.token) {
      config.headers['Token'] = store.getters.token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  })

http.interceptors.response.use(response => {
    let _data = response.data, msg

    if(_data) {
      switch (_data.code) {
        case 0:
          return Promise.resolve(_data.data)
        case 404:
          msg = '访问的资源不存在！'
          break
        case 401:
          msg = '没有访问权限！'
          break
        default:
          msg = '未知错误！'
          break
      }
    }
    msg = _data.message || '请求数据失败！'
    Notification({
      title: '错误',
      message: msg,
      type: 'error',
      duration: 5 * 1000
    })

    return Promise.reject(new Error(msg))
  },
  error => {
    Notification({
      title: '错误',
      message: "获取数据失败！" || error.message,
      type: 'error',
      duration: 5 * 1000
    })

    return Promise.reject(error)
  })

export default http



// WEBPACK FOOTER //
// ./src/utils/http.js